module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABGElEQVQ4je3TvyuFYRjG8Y8Tg0WUzWBRFmbJxEBiJJvNM/mHzltWGxIL8rMsBja72WRRyI/uutXpdBxOFoOr3nq6r+v6Pvfb2+tfv1ZXvV6/RQ1zuOsUWEpRVdUwDvAWoCeM4hIjnQKrqhrJbjCeAjiLGwzhDGMd8MazE93rYAXwHtO4SuM0gz+BnWQnujOllPtamg+5adw2iHNMtIGFd5HZWGC2lBIMtYZQDBYyMIBDTLaATaXXnxsufsKagaFHzGMPfTiOV2nw43yUXmTmSymPjYBmoPzqS9hBL/bzksU8x2wrM8/N5VZAGVzGZgJ2sZ3nmK20grUDhl6xig305FPl7PWrUncb4Cd0DS/xF2Ad7990/vWnhA/900O0ehSLdwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/family/icon/family_menu_down.png
// module id = yILK
// module chunks = 1